import { selectFilterHelper } from "@/helpers";
import { availableParentType } from "@/propTypes";
import { useGetAdminFlatFormsQuery } from "@/services";
import { Form, Input, Select, Switch } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";
export const DateRangeFormField = ({ availableParent }) => {
  const intl = useIntl();
  const [includeTime, setIncludeTime] = useState(false);
  const [parentId, setParentId] = useState();
  const [dependentValues, setDependentValues] = useState([]);

  const { data: { flatForms } = {} } = useGetAdminFlatFormsQuery();

  useEffect(() => {
    if (flatForms && parentId) {
      const index = flatForms.findIndex((x) => x.property.id === parentId);
      if (index >= 0 && flatForms[index].values) {
        const vals = flatForms[index].values.map((item) => ({
          value: item.id,
          text: intl.formatMessage({
            id: item.label.id,
            defaultMessage: item.label.fallback,
          }),
        }));
        setDependentValues(vals);
      }
    } else {
      setDependentValues([]);
    }
  }, [flatForms, intl, parentId]);
  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="includeTime"
        label={intl.formatMessage({
          id: "newFormField.includeTime",
        })}
        valuePropName="checked"
      >
        <Switch
          data-test-id="date-range-form-field-include-time"
          onChange={(toggled) => {
            setIncludeTime(toggled);
          }}
        />
      </Form.Item>
      {includeTime && (
        <>
          <Form.Item
            name="timeParentField"
            label={intl.formatMessage({
              id: "newFormField.timeParentField",
            })}
          >
            <Select
              data-test-id="date-range-form-field-time-parent-field"
              style={{ maxWidth: 500 }}
              allowClear
              onChange={(val) => {
                setParentId(val);
              }}
            >
              {availableParent.key && availableParent.items.length && (
                <Select.OptGroup
                  label={availableParent.key}
                  key={availableParent.key}
                >
                  {availableParent.items.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="timeDependentValues"
            label={intl.formatMessage({
              id: "newFormField.timeDependentValues",
            })}
          >
            <Select
              mode="multiple"
              style={{ maxWidth: 500 }}
              disabled={!parentId}
              allowClear
              placeholder={intl.formatMessage({
                id: "newFormField.dependentValuesPlaceholder",
              })}
              filterOption={selectFilterHelper}
            >
              {dependentValues.map(({ value, text }) => (
                <Select.Option value={value} key={value}>
                  {text}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </>
      )}
    </FormFieldContainer>
  );
};
DateRangeFormField.propTypes = {
  availableParent: availableParentType,
};
